module.exports = __webpack_public_path__ + "img/career.79413a05.svg";